(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yn-dark-store"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yn-lineup')) {
  customElements.define('yn-lineup', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-filter]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('button[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        this.querySelectorAll('[data-category]').forEach(card => { card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter; });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yn-everyday"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('yn-everyday-catalog')) {
  customElements.define('yn-everyday-catalog', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-filter]');
        if (!button || !this.contains(button)) return;
        let visible = 0;
        this.querySelectorAll('button[data-filter]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
        this.querySelectorAll('[data-category]').forEach(card => {
          card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
          if (!card.hidden) visible++;
        });
        this.querySelector('[data-filter-status]').textContent = button.textContent.trim() + ': ' + visible;
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
